import { css, Theme } from '@emotion/react';

// Hover / active / parent colouring shared by the admin rail and the section builder sidebar.
const navItemState = (theme: Theme) => css`
  &:hover {
    color: ${theme.colors.black};

    background-color: ${theme.colors.whiteHover};
  }
  &[data-active='true'],
  &[data-parent='true'] {
    color: ${theme.colors.white};

    background: ${theme.colors.clickable};
    &:hover {
      color: ${theme.colors.white};

      background: ${theme.colors.clickable};
    }
  }
`;

export default navItemState;
